/*=========================================================================================
  File Name: modulePersonnel.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleAppro_caisse_recetteState.js'
import mutations from './moduleAppro_caisse_recetteMutations.js'
import actions from './moduleAppro_caisse_recetteActions.js'
import getters from './moduleAppro_caisse_recetteGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

